import { Form } from 'factorial-form'

class PersonalEmail extends Form {
  // eslint-disable-next-line @typescript-eslint/ban-types
  constructor(values: {}) {
    super(values, {
      personal_email: 'string',
    })
  }
}

export default PersonalEmail
